import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { selectUser } from "@/store/auth/auth.slice";
import { useThunkSelector } from "@/store/hooks";
import { currentPropertySelector } from "@/store/selectors";
import { getTopLevelRole } from "@/utils/roleUtils";

import { initializePendo } from "./initializePendo";
import loadPendo from "./loadPendo";

export default function AnalyticsTags() {
  const user = useThunkSelector(selectUser);
  const { property } = useSelector(currentPropertySelector);
  const { isAuthenticated } = useAuth0();
  const { id: userId, email, name, role, propertyRoles = {} } = user || { id: "", email: "", name: "", role: "" };
  const topRole: string = getTopLevelRole([role, ...Object.values(propertyRoles)]);

  const [pendoLoaded, setPendoLoaded] = useState(false);

  useEffect(() => {
    try {
      if (!pendoLoaded) {
        loadPendo(import.meta.env.VITE_APP_PENDO_API_KEY);
        console.log("Pendo script loaded.");
        setPendoLoaded(true);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    initializePendo({
      property,
      email,
      name,
      userId,
      topRole,
      isAuthenticated,
    });
  }, [isAuthenticated, property?.name, topRole]);

  return <></>;
}
